// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "shift4-frontend-app-shell." + "8d98cd6065e55e045f2e" + ".js";
};